/**
 * Add class to section-padding if it contains only empty elements
 */
(function() {
  function checkEmptySections() {
    const sections = document.querySelectorAll('.section-spacing');
    
    sections.forEach(section => {
      // Check if section is empty or contains only whitespace/empty elements
      const isEmpty = !section.textContent.trim() || 
                      (section.children.length === 0) ||
                      (Array.from(section.children).every(child => !child.textContent.trim()));
      
      if (isEmpty) {
        section.classList.add('section-empty');
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkEmptySections);
  } else {
    checkEmptySections();
  }
})();






/* MW | VUOI DIVENTARE UN SALONE */
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 767) return;

  const section = document.querySelector(
    '#section-id-template--28216294113613__image_with_text_overlay_U4YJi3 .image-overlay > a'
  );

  if (!section) return;

  const image = section.querySelector('.rimage-outer-wrapper');
  const overlay = section.querySelector('.overlay-type');
  const button = section.querySelector('.line-3');

  if (image && overlay) {
    section.insertBefore(overlay, image);
  }

  if (image && button) {
    image.insertAdjacentElement('afterend', button);
  }
});
